import React from "react";
import {Link} from "react-router-dom";
import {ProfessionalProfileRoutes} from "../../../stores/site.map";

const RetakeAssessmentButton: React.FC = () => {
	return (
		<div className="cih-col">
			<div className="cih-txt-lead cih-hide-print">
				<h3 className="cih-h2 cih-mb-2">Ready to retake?</h3>
				<p>Retake the assessment over time to compare your results over time. Your previous reports are stored on this page for the future.</p>
			</div>
			<Link className="no-link cih-flex cih-align-self-center cih-hide-print" to={ProfessionalProfileRoutes.Questionnaire}>
				<button className="arrowbutton __transparent cih-my-1">
					<span className="buttontext">Retake assessment</span>
					<span className="buttonicon">
						<span className="buttonicon-topline"></span>
						<span className="buttonicon-middleline"></span>
						<span className="buttonicon-bottomline"></span>
					</span>
				</button>
			</Link>
		</div>
	);
};

export default RetakeAssessmentButton;
